<div class="row">
  <div class="col-md-4">
      <h4>LLenado de notas:</h4>
      <a *ngFor="let std of listOfStudents$ | async" routerLink="./scores/{{std.id }}">
        <span>{{ std.data.name }} {{ std.data.fatherName }} {{ std.data.motherName }} </span>
        <br>
      </a>      
  </div>
</div>